const PIXEL_ID = '949582520795873'

let initialized = false

export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return

  // Load the Facebook Pixel script
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Initialize pixel and fire PageView
  f.fbq('init', PIXEL_ID)
  f.fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('img')
  noscript.height = 1
  noscript.width = 1
  noscript.style.display = 'none'
  noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscript)

  initialized = true
}

export function trackAddToCart(): void {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', 'AddToCart', {
      content_name: "The Voice They Couldn't Silence - Digital Edition",
      content_type: 'product',
      value: 13.99,
      currency: 'USD',
    })
  }
}
